<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalConfirmation } from '@shared/ui/modals'
import { AppIcon } from '@shared/ui/icons'
import { BtnToggle } from '@shared/ui/buttons'

import { useUserAvailability } from '../composables/user-availability.hook'

defineOptions({
  name: 'UserAvailability',
})

const {
  isAvailable,
  statusText,
  modal,
  isModalShown,
  isLoading,
  setModalShown,
  setAvailability,
} = useUserAvailability()
</script>

<template>
  <div class="user-availability">
    <div
      class="user-availability__toggle"
      :title="statusText"
      @click="setModalShown(true)"
    >
      <BtnToggle
        color="emerald"
        tooltip-text="Change status"
        :checked="isAvailable"
        :disabled="isLoading"
        :readonly="true"
      />
      <AppText
        name="body1"
        tag="span"
        color="slate-900"
        class="user-availability__text"
      >
        {{ statusText }}
      </AppText>
    </div>
    <ModalConfirmation
      :show="isModalShown"
      :mode="modal.mode"
      :title="modal.title"
      :detail="modal.detail"
      :button-title="modal.title"
      :loading="isLoading"
      @click:confirm="setAvailability"
      @click:cancel="setModalShown(false)"
    >
      <template #icon>
        <AppIcon
          :icon="modal.icon"
          :color="modal.iconColor"
        />
      </template>
    </ModalConfirmation>
  </div>
</template>

<style scoped lang="scss" src="./UserAvailability.scss" />
